import { AllRoles, AdminRoles } from "@/helper/roles";

const restaurantRoutes = [
  {
    path: "restaurant",
    meta: { translated: false, label: "restaurant.restaurant" },
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: [
      { path: 'set-menus', name: 'SetMenus', meta: { translated: false, label: 'set_menu.title', authorize: AdminRoles }, component: () => import('@/views/restaurants/set-menus/List.vue') },
      { path: 'set-menus/add', name: 'AddSetMenu', meta: { translated: false, label: 'set_menu.add', authorize: AdminRoles }, component: () => import('@/views/restaurants/set-menus/Item.vue') },
      { path: 'set-menus/:id', name: 'EditSetMenu', meta: { translated: false, label: 'set_menu.edit', authorize: AdminRoles }, component: () => import('@/views/restaurants/set-menus/Item.vue') },
      {
        path: "stations",
        name: "RestaurantStations",
        meta: { translated: false, label: "station.title", authorize: AdminRoles },
        component: () => import("@/views/restaurants/stations/List.vue"),
      },
      {
        path: "dashboard",
        alias: [""],
        name: "Restaurant Dashboard",
        meta: { translated: false, label: "restaurant.dashboard", authorize: AllRoles },
        component: () => import("@/views/restaurant-views/Dashboard"),
      },

      //#region Products
      {
        path: "products",
        meta: { translated: false, label: "product.products", authorize: AdminRoles },
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "",
            name: "Products",
            meta: {
              translated: false,
              label: "product.all_products",
              allowAddToWarehouse: true,
              authorize: AdminRoles,
            },
            component: () => import("@/views/products/List"),
          },
          {
            path: "add",
            name: "Add New Product",
            meta: { translated: false, label: "product.add_new_product", authorize: AdminRoles },
            component: () => import("@/views/products/Item"),
          },
          {
            path: "bulk",
            name: "Add Bulk Product",
            meta: {
              translated: false,
              label: "product.bulk.add_bulk_product",
              authorize: AdminRoles,
            },
            component: () => import("@/views/products/bulk/Excel"),
          },
          {
            path: "quick",
            name: "Add Quick Products",
            meta: {
              translated: false,
              label: "product.quick_product_addition",
              authorize: AdminRoles,
            },
            component: () =>
              import("@/views/restaurant-views/products/quick/List"),
          },
          {
            path: "pool",
            name: "Product Pool",
            meta: { translated: false, label: "product.product_pool", authorize: AdminRoles },
            component: () => import("@/views/products/pool/List"),
          },
          {
            path: ":id",
            name: "Edit Product",
            meta: { translated: false, label: "product.edit_product", authorize: AdminRoles },
            component: () => import("@/views/products/Item"),
          },
        ],
      },
      //#endregion

      //#region Menus
      {
        path: "menus",
        meta: { translated: false, label: "menu.menus", authorize: AdminRoles },
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "",
            name: "Menus",
            meta: { translated: false, label: "menu.menus", authorize: AdminRoles },
            component: () => import("@/views/restaurants/menus/List"),
          },
          {
            path: "add",
            name: "Add New Menu",
            meta: { translated: false, label: "menu.add_new_menu", authorize: AdminRoles },
            component: () => import("@/views/restaurants/menus/Item"),
          },
          {
            path: "products/bulk",
            name: "Add Bulk Restaurant Product",
            meta: {
              translated: false,
              label: "product.bulk.add_bulk_product",
              authorize: AdminRoles,
            },
            component: () => import("@/views/products/bulk/Excel"),
          },
          {
            path: ":menu_id?/products",
            name: "Menu Products",
            meta: {
              translated: false,
              label: "menu.menu_products",
              allowAddToWarehouse: false,
              authorize: AdminRoles,
            },
            component: () => import("@/views/products/List"),
          },
          {
            path: ":menu_id?/products/add",
            name: "Add New Menu Product",
            meta: { translated: false, label: "product.add_new_product", authorize: AdminRoles },
            component: () => import("@/views/products/Item"),
          },
          {
            path: ":menu_id?/products/:id",
            name: "Edit Menu Product",
            meta: { translated: false, label: "product.edit_product", authorize: AdminRoles },
            component: () => import("@/views/products/Item"),
          },

          {
            path: ":id",
            name: "Edit Menu",
            meta: { translated: false, label: "menu.edit_menu", authorize: AdminRoles },
            component: () => import("@/views/restaurants/menus/Item"),
          },
        ],
      },
      //#endregion

      //#region Extras
      {
        path: "extras",
        meta: { translated: false, label: "extra.extras", authorize: AdminRoles },
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "",
            name: "Extras",
            meta: { translated: false, label: "extra.extras", authorize: AdminRoles },
            component: () => import("@/views/restaurants/extras/List"),
          },
        ],
      },
      //#endregion

      //#region Options
      {
        path: "options",
        meta: { translated: false, label: "product.options.options", authorize: AdminRoles },
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "",
            name: "AllOptions",
            meta: { translated: false, label: "product.options.options", authorize: AdminRoles },
            component: () => import("@/views/restaurants/options/Item"),
          },
        ],
      },
      //#endregion

      //#region Warehouses
      {
        path: "warehouses",
        meta: { translated: false, label: "warehouse.warehouse", authorize: AdminRoles },
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "",
            name: "Warehouses",
            meta: { translated: false, label: "warehouse.warehouses", authorize: AdminRoles },
            component: () => import("@/views/warehouses/List"),
          },
          {
            path: "add",
            name: "Add New Warehouse",
            meta: { translated: false, label: "warehouse.add_new_warehouse", authorize: AdminRoles },
            component: () => import("@/views/warehouses/Item"),
          },

          // Warehouse Products
          {
            path: ":id/products",
            name: "WarehouseProducts",
            meta: {
              translated: false,
              label: "warehouse.warehouse_products",
              authorize: AdminRoles,
            },
            component: () => import("@/views/warehouses/products/List"),
          },
          {
            path: ":id/products/:product_id",
            name: "Edit Warehouse Product",
            meta: {
              translated: false,
              label: "warehouse.edit_warehouse_product",
              authorize: AdminRoles,
            },
            component: () => import("@/views/warehouses/products/Item"),
          },
          {
            path: "products",
            name: "AllWarehouseProducts",
            meta: {
              translated: false,
              label: "warehouse.warehouse_products",
              authorize: AdminRoles,
            },
            component: () => import("@/views/warehouses/products/List"),
          },
          {
            path: "analysis",
            name: "WarehouseProductAnalysis",
            meta: {
              translated: false,
              label: "warehouse.analysis_title",
              authorize: AdminRoles,
            },
            component: () => import("@/views/warehouses/analysis/List"),
          },

          // Shipping Areas
          {
            path: ":id/shipping-areas",
            name: "ShippingAreas",
            meta: { translated: false, label: "warehouse.shipping_areas", authorize: AdminRoles },
            component: () => import("@/views/warehouses/shipping_areas/List"),
          },
          {
            path: ":id/shipping-areas/add",
            name: "Add New ShippingArea",
            meta: {
              translated: false,
              label: "warehouse.add_new_shipping_area",
              authorize: AdminRoles,
            },
            component: () => import("@/views/warehouses/shipping_areas/Item"),
          },
          {
            path: "shipping-areas",
            name: "AllShippingAreas",
            meta: { translated: false, label: "warehouse.shipping_areas", authorize: AdminRoles },
            component: () => import("@/views/warehouses/shipping_areas/List"),
          },

          // Edit Warehouse
          {
            path: ":id",
            name: "Edit Warehouse",
            meta: { translated: false, label: "warehouse.edit_warehouse", authorize: AdminRoles },
            component: () => import("@/views/warehouses/Item"),
          },
        ],
      },
      //#endregion

      //#region Customer Orders
      {
        path: "customer-orders",
        meta: { translated: false, label: "order.orders", authorize: AdminRoles },
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "",
            name: "Orders",
            meta: { translated: false, label: "order.customer_orders", authorize: AdminRoles },
            component: () =>
              import("@/views/restaurant-views/customer-orders/List"),
          },
          {
            path: ":str_id",
            name: "Order Details",
            meta: { translated: false, label: "order.details", authorize: AdminRoles },
            component: () =>
              import("@/views/restaurant-views/customer-orders/Details"),
          },
        ],
      },
      //#endregion

      //#region Supplier Orders
      {
        path: 'deposit-accounts',
        name: 'RestaurantDepositAccounts',
        meta: { translated: true, label: 'deposit_accounts.title', authorize: AllRoles },
        component: () => import('@/views/restaurant-views/deposits/List'),
      },

      {
        path: "supplier-orders",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        meta: { translated: false, label: "order.orders", authorize: AllRoles },
        children: [
          // All Supplier Orders List
          {
            path: "",
            name: "SupplierOrders",
            meta: { translated: false, label: "order.supplier_orders", authorize: AllRoles },
            component: () =>
              import(
                "@/views/restaurant-views/supplier-orders/all-orders/List"
              ),
          },

          // Check Supplier Orders
          {
            path: "check",
            meta: { translated: false, label: "order.supplier_orders", authorize: AllRoles },
            component: {
              render(c) {
                return c("router-view");
              },
            },
            children: [
              {
                path: "",
                name: "CheckSupplierOrders",
                meta: { translated: false, label: "order.order_check", authorize: AllRoles },
                component: () =>
                  import("@/views/restaurant-views/supplier-orders/check/List"),
              },
              {
                path: "multiple/:receiptId",
                name: "CheckMultipleSupplierOrders",
                meta: { translated: false, label: "order.multiple_goods_receipt", authorize: AllRoles },
                component: () =>
                  import("@/views/restaurant-views/supplier-orders/check/MultiReceipt"),
              },
              {
                path: ":id",
                name: "CheckSupplierOrderDetails",
                meta: { translated: false, label: "order.details", authorize: AllRoles },
                component: () =>
                  import("@/views/restaurant-views/supplier-orders/check/Item"),
              },
            ],
          },

          // New Supplier Order
          {
            path: "new",
            name: "NewSupplierOrder",
            meta: { translated: false, label: "order.new_supplier_order", authorize: AllRoles },
            component: () =>
              import(
                "@/views/restaurant-views/supplier-orders/new-order/ProductList"
              ),
          },

          // Price Optimizer
          {
            path: "price-optimizer",
            name: "PriceOptimizer",
            meta: {
              translated: false,
              label: "order.price_optimizer.title",
              authorize: AllRoles,
              backRoute: { name: "NewSupplierOrder" },
            },
            component: () =>
              import(
                "@/views/restaurant-views/supplier-orders/new-order/PriceOptimizer"
              ),
          },
          {
            path: "review",
            name: "SupplierOrderReview",
            meta: {
              translated: false,
              label: "order.cart.review_and_approve",
              authorize: AllRoles,
              backRoute: { name: "NewSupplierOrder" },
            },
            component: () =>
              import(
                "@/views/restaurant-views/supplier-orders/new-order/OrderReview"
              ),
          },
        ],
      },
      //#endregion

      //#region Company Users
      {
        path: "company-users",
        name: "CompanyUsers",
        meta: { translated: false, label: "user.company_users", authorize: AdminRoles },
        component: () => import("@/views/restaurant-views/company-users/List"),
      },
      //#endregion

      //#region Settings
      {
        path: "settings",
        meta: { translated: false, label: "settings.settings", authorize: AdminRoles },
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          //#region Cashpad
          {
            path: "cashpad",
            meta: { translated: false, label: "cashpad.cashpad", authorize: AdminRoles },
            component: {
              render(c) {
                return c("router-view");
              },
            },
            children: [
              {
                path: "",
                name: "Cashpad",
                meta: { translated: false, label: "cashpad.cashpad_info", authorize: AdminRoles },
                component: () => import("@/views/cashpad/Item"),
              },
              {
                path: "products",
                name: "Cashpad Products",
                meta: { translated: false, label: "cashpad.products", authorize: AdminRoles },
                component: () => import("@/views/cashpad/Products"),
              },
              {
                path: "extras",
                name: "Cashpad Extras",
                meta: { translated: false, label: "cashpad.extras", authorize: AdminRoles },
                component: () => import("@/views/cashpad/Extras"),
              },
              {
                path: "ingredients",
                name: "Cashpad Ingredients",
                meta: {
                  translated: false,
                  label: "cashpad.products_used_as_ingredients",
                  authorize: AdminRoles,
                },
                component: () => import("@/views/cashpad/Ingredients"),
              },
            ],
          },
          //#endregion
        ],
      },
      //#endregion

      //#region HappyGast
      {
        path: ":happy_gast_id",
        name: "Restaurant Dashboard With HappyGast Id",
        meta: { translated: false, label: "restaurant.dashboard", authorize: AllRoles },
        component: () => import("@/views/restaurant-views/Dashboard"),
      },
      //#endregion
    ],
  },
];

export default restaurantRoutes;
